import {NavigationController} from './navigationController';

export function navigation(): ng.IDirective {
    return {
        restrict: "A",
        controller: NavigationController,
        controllerAs: "nav"
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/navigation/navigation.directive.ts
 **/